
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class NebulaDriftEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, globalHue } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing * 2);

        for (let x = x1; x <= x2; x += spacing * 2) {
            for (let y = y1; y <= y2; y += spacing * 2) {
                const offX = this.pseudoRandom(x + layerIndex) * spacing;
                const offY = this.pseudoRandom(y + layerIndex) * spacing;
                const r = spacing * (1 + this.pseudoRandom(x * y) * 1.5) * (config.parallaxScale || 1.0);
                
                const draw = () => {
                    const grad = ctx.createRadialGradient(x + offX, y + offY, 0, x + offX, y + offY, r);
                    const color = pc.color;
                    grad.addColorStop(0, color);
                    grad.addColorStop(1, 'transparent');
                    
                    ctx.fillStyle = grad;
                    ctx.beginPath();
                    ctx.arc(x + offX, y + offY, r, 0, Math.PI * 2);
                    ctx.fill();
                };

                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
